import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import 'filepond/dist/filepond.min.css';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useAuthStore } from './store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useAuthStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})